<template>
  <div class="auth-layout flex lg:h-screen">
    <router-link to="/" class="auth-layout__logo hidden md:block">
      <img
        width="145px"
        src="https://storage.googleapis.com/rio-public/hyperlead-pub-web/hyperlead-logo.png"
        alt="login"
        class="mx-auto"
      />
    </router-link>

    <div
      v-if="responsive.carousel.show"
      class="auth-layout__left vx-col w-full hidden lg:flex items-center justify-center"
    >
      <div
        class="auth-layout__left__image flex items-center justify-center px-10"
      >
        <carousel
          ref="authCarousel"
          :loop="true"
          :navigationEnabled="true"
          :paginationEnabled="false"
          :autoplay="slideImages.is_slider"
          :autoplayTimeout="slideImages.slider_delay * 1000"
          :autoplayHoverPause="true"
          :perPage="1"
          navigationNextLabel="<i style='font-size: 24px!important' class='vs-icon text-primary notranslate icon-scale material-icons null'>chevron_right</i>"
          navigationPrevLabel="<i style='font-size: 24px!important' class='vs-icon text-primary notranslate icon-scale material-icons null'>chevron_left</i>"
        >
          <slide
            v-for="(item, index) in slideImages[slideImages.type_banner]"
            :key="index"
          >
            <a
              v-if="slideImages.type_banner === 'images'"
              :href="item.direct_link ? item.direct_link : 'javascript:void(0)'"
              :target="item.direct_link ? '_blank' : ''"
            >
              <img :src="item.url" alt="login" class="mx-auto" loading="lazy"
            /></a>
            <iframe
              v-else
              :src="item.url"
              frameborder="0"
              class="mx-auto"
              allow="autoplay; fullscreen; picture-in-picture"
              allowfullscreen
            >
            </iframe>
          </slide>
        </carousel>
      </div>
    </div>
    <div
      class="auth-layout__right p-8 md:p-20 vx-col d-theme-dark-bg flex flex-col justify-center mx-auto lg:mx-0 self-start overflow-y-auto"
    >
      <!-- Language VI / EN -->
      <vs-dropdown
        vs-custom-content
        vs-trigger-click
        class="auth-layout__right__language cursor-pointer"
      >
        <div class="flex items-center">
          <img
            class="h-7 w-10 inline-block"
            :src="i18nImg"
            :alt="$i18n.locale"
          />
          <span class="ml-2">{{
            $i18n.locale === "en" ? "English" : "Tiếng việt"
          }}</span>
          <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4 ml-1" />
        </div>
        <vs-dropdown-menu class="w-48 vx-navbar-dropdown">
          <vs-dropdown-item @click="onUpdateLocale('en')">
            <img
              class="h-4 w-5 mr-2"
              src="@assets/images/flags/en.webp"
              alt="en"
            />English
          </vs-dropdown-item>
          <vs-dropdown-item @click="onUpdateLocale('vi')">
            <img
              class="h-4 w-5 mr-2"
              src="@assets/images/flags/vi.webp"
              alt="vi"
            />Tiếng Việt
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>

      <router-link
        to="/"
        class="auth-layout__right__logo block md:hidden text-center mb-6"
      >
        <img
          width="145px"
          src="https://storage.googleapis.com/rio-public/hyperlead-pub-web/hyperlead-logo.png"
          alt="login"
          class="mx-auto"
        />
      </router-link>

      <!-- Login / Sign up / Forget password Page slot -->
      <slot></slot>

      <!-- <vs-divider v-if="isPage !== 'register' || isPage === 'login'" class="my-5 mb-8">{{ $t('login.or') }}</vs-divider> -->

      <!-- Login / Regiter with -->
      <div
        v-if="isPage === 'register' || isPage === 'login'"
        class="auth-layout__right__accessibility flex flex-wrap justify-center"
      >
        <p v-if="isPage === 'register'" class="text-dark mt-4 mb-5">
          {{ $t("login.areYouHaveAnAccount") }}
          <router-link class="text-primary font-semibold" to="/login">{{
            $t("login.loginNow")
          }}</router-link>
        </p>

        <p
          v-if="isPage === 'register'"
          class="auth-layout__right__accessibility__acceptTermsQuote text-center text-gray"
        >
          {{ $t("login.acceptTermsQuote") }}
          <router-link
            :to="{ name: 'terms-and-conditions' }"
            class="text-primary"
            >{{ $t("login.termsAndConditions") }}</router-link
          >
			{{ $t("login.and") }}
			<router-link
			:to="{ name: 'privacy-policy' }"
			class="text-primary"
		>{{ $t("login.privacyPolicy") }}</router-link
		>
          {{ $t("login.ourAbout") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import useStylesheet from "../../core/helpers/useStylesheet";
import brandingImage from "@assets/images/logo/hyperlead.png";
import Button from "../components/../../components/Button/Button.vue";

export default {
  name: "auth-layout",
  components: {
    Button,
    Carousel,
    Slide,
  },
  data() {
    return {
      branding: brandingImage,
      responsive: {
        carousel: {
          min: 991,
          show: true,
        },
      },
    };
  },
  props: {
    isPage: String, // "login" | "register" | "forget" | "reset",

    slideImages: {
      type: Object,
      default: {},
    },
  },
  computed: {
    i18nImg() {
      if (this.$i18n.locale === "en") {
        return require("@assets/images/flags/en.webp");
      }
      return require("@assets/images/flags/vi.webp");
    },
  },
  watch: {
    slideImages: {
      handler() {
        if (this.slideImages.type_banner) {
          setTimeout(() => {
            this.computingRatioOfSliders();
          }, 100);
        }
      },
      deep: true,
    },
  },
  methods: {
    onUpdateLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("language", locale);
      this.$root.$emit("updateI18n");
    },

    computingRatioOfSliders() {
      const currentWidth = window.innerWidth;
      const currentFrames = { w: window.innerHeight, h: window.innerHeight };
      const originalRatio = { w: 1.9 - 0.68, h: 1.42 - 0.68 };
      const { setPropertyCss } = useStylesheet();

      setPropertyCss(
        "--hl-auth-carousel-w",
        `${currentFrames.w / originalRatio.w}px`
      );
      setPropertyCss(
        "--hl-auth-carousel-h",
        `${currentFrames.h / originalRatio.h}px`
      );

      setPropertyCss(
        "--hl-auth-carousel-h-current",
        `${currentFrames.h / 1.5}px`
      );

      let typeBanner = this.slideImages.type_banner;
      let slideImagesLength = 0;
      if (typeBanner === "videos") {
        slideImagesLength = this.slideImages[typeBanner].length;
        if (slideImagesLength === 1) {
          $(
            ".auth-layout .auth-layout__left__image .VueCarousel .VueCarousel-wrapper .VueCarousel-slide iframe"
          ).css("width", `${currentFrames.h / 1.5}px`);
        }
      }

      console.log(
        currentFrames,
        `${currentFrames.w / originalRatio.w}px`,
        `${currentFrames.h / originalRatio.h}px`
      );
      // Computed responsive
      this.responsive.carousel.show =
        this.responsive.carousel.min < currentWidth;

      this.$forceUpdate();
    },
  },

  mounted() {
    setTimeout(() => {
      this.$forceUpdate();
    }, 500);

    this.computingRatioOfSliders();
    window.addEventListener("resize", this.computingRatioOfSliders);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.computingRatioOfSliders);
  },
};
</script>

<style lang="scss">
.auth-layout {
  margin-bottom: -21px;

  .auth-layout__logo {
    position: fixed;
    top: 30px;
    left: 30px;
    z-index: 100;
  }

  .auth-layout__left {
    &__image {
      max-width: var(--hl-auth-carousel-w, 1);
      max-height: var(--hl-auth-carousel-h-current, 1);
      width: 100%;
      height: 100%;

      img,
      iframe {
        width: 100%;
        height: 100%;
      }

      .VueCarousel {
        min-width: var(--hl-auth-carousel-w, 1);
        min-height: var(--hl-auth-carousel-h-current, 1);
        .VueCarousel-wrapper {
          position: relative;

          .VueCarousel-slide {
            iframe {
              max-width: var(--hl-auth-carousel-w, 1);
              max-height: var(--hl-auth-carousel-h-current, 1);
            }

            iframe {
              height: var(--hl-auth-carousel-w, 1);
            }
          }

          .VueCarousel-pagination,
          .VueCarousel-pagination[data-v-438fd353] {
            position: absolute;
            bottom: 0;
          }
        }
      }
    }
  }

  .auth-layout__right {
    max-width: 484px;
    width: 100%;
    min-height: 100vh;



    .auth-layout__right__language {
      top: 40px;
      right: 45px;
      position: absolute;
    }

    .auth-layout__right__accessibility {
      .auth-layout__right__accessibility__acceptTermsQuote {
        margin-top: auto;
      }
    }
  }
}

@media screen and (max-width: 996px) {
  body {
    background-color: var(--vs-hex--white);
  }
}

@media screen and (max-width: 525px) {
  .auth-layout {


    .auth-layout__left {
      &__image {
        img {
        }
      }
    }

    .auth-layout__right {
      .auth-layout__right__logo {
        margin-bottom: 32px !important;
      }

      .auth-layout__right__language {
        position: static;
        margin-bottom: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .auth-layout__right__accessibility {
        .auth-layout__right__accessibility__acceptTermsQuote {
          position: static;
          margin-top: 27px;

          padding: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/auth/AuthLayout.vue